
export interface Data {
    [key: string]: any;
}

class Config {
    private data: Data = [];
    private static instance: Config = null;

    private constructor () {
    }

    public setAll (data: Data): void {
        this.data = data;
    }

    public set (key: string, value: any): void {
        this.data[key] = value;
    }

    public get (key: string, defaultResponse: any = false): any {
        return this.data[key] || defaultResponse;
    }

    public static getInstance () {
        if (Config.instance === null)
            Config.instance = new Config();

        return Config.instance;
    }
}

export default Config.getInstance();

